import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { getDocumentNumber } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { AuthGuardService } from '../../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { IDocumentTree, TreeService } from '../../../../@core/service/tree.service';
import { CompilationModel, ErpDate, TransportRun } from '../../../../@models/erp/compilation';
import { AvailabilityStatusData, CompilationTypeData, DocConfig, PaymentDates, SpoStatusData, TransportStatusData, UnitData } from '../../../../@models/erp/compilationData';
import { Changelog } from '../../shared/changelog/changelog.component';
import { EDebugType } from '../../../../@models/debug';

export class ReportDates {
  public static getMinField(compilations: CompilationModel[], field: string, lineItems = false) {
    return ReportDates.getMinMaxField(compilations, field, lineItems, true);
  }

  public static getMaxField(compilations: CompilationModel[], field: string, lineItems = false) {
    return ReportDates.getMinMaxField(compilations, field, lineItems, false);
  }

  public static getMinMaxField(compilations: CompilationModel[], field: string, lineItems = false, min = true) {
    let fields = [];
    if (lineItems) {
      const lis = (compilations.map(m => m.lineItems) || []).reduce((a,c) => [...a, ...c], []);
      // console.log('lis', lis)
      fields = lis && lis.map(li => li[field]);
      if (!fields || !fields.length) return null;
    } else {
      fields = compilations.map(c => c[field]);
    }
    // console.log('fields', fields)
    return fields && (min ? fields.reduce((a,c) => a < c ? a : c, 0) : fields.reduce((a,c) => a > c ? a : c, 0));
  }
}

@Component({
  selector: 'ngx-report-dates',
  templateUrl: './report-dates.component.html',
  styleUrls: ['./report-dates.component.scss'],
})
export class ReportDatesComponent implements OnInit, OnChanges, DoCheck, OnDestroy {

  @Input() compilation: CompilationModel;
  // @Input() compilationData: any;
  @Input() print: boolean = false;
  @Input() disabled: boolean = true;
  @Input() syncOnLoad = false;
  @Output() dateChange = new EventEmitter<void>();
  @Output() savedCSSPO = new EventEmitter<CompilationModel>();


  docConfig = DocConfig;
  typeData = CompilationTypeData;
  unitData = UnitData;
  spoStatusData = SpoStatusData;
  transportStatusData = TransportStatusData;
  paymentDateOptions = PaymentDates.getOptions();
  console = console;
  

  displayDateSections: any = [];

  documentTree: any;

  combinedShipment: CompilationModel;

  prevCodes = [];
  currCodes = [];

  csDateToggle = false;
  pfspoDateToggle = false;
  ocDateToggle = false;

  csTable = [];
  pfspoTable = [];
  ocTable = [];

  transportStatus = 0;

  dateTextOptions: { id: string, name: string }[];

  reportDateFields = DocConfig.getArray()
    .filter(f => f.value['type'] === 'reportDate' || f.value['type'] === 'reportNumber');

  csSpoDatesUnlocked = false;
  referenceSpoCode: string = null;
  csSpoDateFields = [
    'dateOfDrawings', 'dateOfSourcing', 'dateOfFAT', 'exwDate', 'dateOfVieArrival', 'dateOfDispatch', 'dateOfDelivery', 'dateOfSAT', 'warrantyMonths', 'endOfWarranty',
    'requestedExwDate', 'internalExwDate', 'exwJapanDate', 'transferTime1', 'arrivingVieDate'
  ];

  checkDisabled = (section: string) => {
    if (this.csSpoDatesUnlocked && !this.disabled && this.csSpoDateFields.includes(section)) {
      return false;
    }
    if (this.compilation.directDelivery && (section === 'vieDispatchDate' || section === 'transferTime2' || section === 'etaCustomerDate')
    ) {
      return true;
    // } else if (this.tree.linkedCS && (section === 'requestedExwDate' || section === 'exwJapanDate' || section === 'transferTime1' || section === 'arrivingVieDate')) {
    } else if (this.tree.linkedCS && (section === 'exwJapanDate' || section === 'transferTime1' || section === 'arrivingVieDate')) {
      return true;
    } else if (
      this.data.visibleMap.pfspoWithShipment
      && (!this.compilation.pfspoWithShipment && !this.disabled
      // && ((section === 'requestedExwDate' && !this.compilation.requestedExwDate) || section === 'exwJapanDate' || section === 'transferTime1' || section === 'arrivingVieDate'))
      && (section === 'exwJapanDate' || section === 'transferTime1' || section === 'arrivingVieDate'))
      ) {
      return false
    }

    if (section === 'expectedNextInvoiceDate' && this.compilation.nextInvoiceDateAttached) return true;

    return this.disabled || this.data.readOnlyMap[section];
  }

  getLinkedCS() {
    return this.tree.linkedCS || (this.tree.linkedCSs && this.tree.linkedCSs[0]) || null;
  }

  getSelectableSpos() {
    return (this.tree.linkedPfspos && this.tree.linkedPfspos.filter(f => f)) || [];
  }

  getSpoOptions() {
    return this.getSelectableSpos().map(s => ({ id: s.code, name: getDocumentNumber(s) || s.code }));
  }

  getUnlockLabel() {
    return this.getLinkedCS() ? 'unlock GS' : 'unlock SPO';
  }

  canUnlockCsSpoDates() {
    if (this.print || this.disabled) return false;
    return !!this.getLinkedCS() || this.getSelectableSpos().length > 0;
  }

  unlockCsSpoDates() {
    if (!this.canUnlockCsSpoDates()) return;
    this.csSpoDatesUnlocked = true;
    const spos = this.getSelectableSpos();
    if (!this.getLinkedCS()) {
      if (spos.length === 1) {
        this.referenceSpoCode = spos[0].code;
      } else if (spos.length > 1 && !this.referenceSpoCode) {
        const idx = this.getMaxField(spos, 'arrivingVieDate').idx;
        this.referenceSpoCode = (idx >= 0 && spos[idx].code) || spos[0].code;
      }
    }
    if (this.referenceSpoCode) (this.compilation as any).refSpoCode = this.referenceSpoCode;
    this.evalFields();
  }

  lockCsSpoDates() {
    this.csSpoDatesUnlocked = false;
    this.referenceSpoCode = null;
    (this.compilation as any).refSpoCode = null;
  }

  referenceSpoChanged(code: string) {
    this.referenceSpoCode = code;
    (this.compilation as any).refSpoCode = code;
  }

  getCsSpoSaveTarget() {
    if (this.getLinkedCS()) return this.getLinkedCS();
    const spos = this.getSelectableSpos();
    if (this.referenceSpoCode) {
      const ref = spos.find(s => s.code === this.referenceSpoCode);
      if (ref) return ref;
    }
    return spos[0] || null;
  }

  async saveUnlockedCsSpoDates() {
    if (!this.csSpoDatesUnlocked || this.disabled) return;
    const targetCode = this.getCsSpoSaveTarget()?.code;
    if (!targetCode || targetCode === this.compilation.code) return;
    const target = await this.api.loadCompilationByCode(targetCode);
    // this.console.log('saveUnlockedCsSpoDates', target.code);
    for (const field of this.csSpoDateFields) {
      // this.console.log('saveUnlockedCsSpoDates', field, target.code, this.compilation[field], target[field])
      const oldValue = target[field];
      const newValue = this.compilation[field];
      if (newValue == null) continue;
      const dateField = DocConfig.get(field).type === 'reportDate';
      const oldStr = oldValue == null ? 'undefined' : (dateField ? new Date(oldValue).toISOString().replace(/T.*/, '') : String(oldValue));
      const newStr = newValue == null ? 'undefined' : (dateField ? new Date(newValue).toISOString().replace(/T.*/, '') : String(newValue));
      if (oldStr === newStr) continue;
      await Changelog.addAndSaveAutolog(target, this.auth.user, this.api, [{
        quickText: 'updated ' + DocConfig.get(field).label,
        text: `from ${oldStr} to ${newStr} in ${getDocumentNumber(this.compilation)}`,
      }]);
      this.console.log('saveUnlockedCsSpoDates2', target.code, field, newValue);
      // await this.api.updateField(target.code, field, newValue);
      target[field] = newValue;
    }
    // this.console.log('---saveUnlockedCsSpoDates', target.code)
    target.editCount += 1;
    target.issueDate = new Date();
    await this.api.saveCompilation(target);
    this.savedCSSPO.emit(target);
  }

  subscriptions = [];


  constructor(
    private api: ApiService,
    public data: SharedDataService,
    private auth: AuthGuardService,
    private cdRef: ChangeDetectorRef,
    public tree: TreeService) {
  }

  ngOnInit() {

    if (!this.compilation.requestedExwDate) {
      this.compilation.requestedExwDate = this.compilation.firstDate?.exwJapanDate;
    }

    console.log('report dates init', this.compilation.expectedNextInvoiceDate, this.compilation.nextInvoiceDateAttached, this.compilation.nextInvoiceDateRef, this.compilation.vieDispatchDate, this.tree.linkedOC?.vieDispatchDate);

    if (!this.compilation.expectedNextInvoiceDate) {
      this.compilation.expectedNextInvoiceDate = this.compilation.vieDispatchDate;
    }
    if (!this.compilation.customerRequestedDeliveryDate) {
      this.compilation.customerRequestedDeliveryDate = this.compilation.etaCustomerDate;
    }
    if (!this.compilation.customerAcceptedDeliveryDate) {
      this.compilation.customerAcceptedDeliveryDate = this.compilation.etaCustomerDate;
    }
    if (this.compilation.nextInvoiceDateAttached === true || this.compilation.nextInvoiceDateRef) {
      // this.compilation.nextInvoiceDateAttached = true;
      this.compilation.expectedNextInvoiceDate = this.compilation.nextInvoiceDateRef 
        ? this.compilation[this.compilation.nextInvoiceDateRef]
        : this.compilation.vieDispatchDate;
    }

    // console.log('availability', this.compilation.code, this.compilation.transportRun.availabilityStatus);
    // if (!this.compilation.transportRun.availabilityStatus) {
    //   this.compilation.transportRun.availabilityStatus = AvailabilityStatusData.get('notCompleted').id;
    //   console.log('availability', this.compilation.code, this.compilation.transportRun.availabilityStatus);
    //   this.cdRef.detectChanges();
    // }

    // this.tree.documentTreeLoadedEvent.subscribe(tree => {
    //   this.ngOnChanges({ tree: tree } as unknown as SimpleChanges); // TODO: ugly
    // })
    this.subscriptions.push(this.tree.documentTreeLoadedEvent.subscribe(tree => {
      this.ngOnChanges({ tree: tree } as unknown as SimpleChanges); // TODO: ugly
    }))

    this.loadDateTextStore();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.tree || (changes.compilation && !changes.tree
      && !this.tree.isLoading && this.tree.docNode
      && this.tree.docNode.doc?.code === this.compilation?.code)) {

      this.referenceSpoCode = (this.compilation as any)?.refSpoCode || null;
      this.documentTree = changes.tree; // await DocumentTree.getDefaultTree(this.api, this.compilation.code, true);
      this.prevCodes = (this.compilation.lineItems && this.compilation.lineItems.map(li => li.pfspo && li.pfspo.map(spo => spo.code)) || [])
        .reduce((acc, curr) => curr && [...acc, ...curr], []);
      // if (DocConfig && this.prevCodes) this.handlePfspoChange(this.prevCodes[0]);

      // console.log('report ', CompilationTypeData.get(this.compilation.type).code, !this.compilation.customerRequestedDeliveryDate);
      // if (CompilationTypeData.get(this.compilation.type).code === 'OC' && !this.compilation.customerRequestedDeliveryDate) {
      //   // console.log('calcMin');
      //   this.compilation.customerRequestedDeliveryDate = ReportDates.getMinField([this.compilation], 'dateOfDelivery', true);
      // }

      // await new Promise(resolve => setTimeout(() => resolve(true), 5000));
      const doc = this.tree.findDoc(this.compilation.code);
      const csDocs = doc && doc.lineItems.map(m => m.pfspo);
      const spos = csDocs && csDocs.reduce((a, c) => c && [...a, ...c], []);
      // const csos = spos.map(spo => spo.doc.transportRun.csDoc && ({ spo: spo, cs: spo.doc.transportRun.csDoc})).filter(f => f);
      // console.log('css', csos);
      // const cssspos = csos.map(cso => {
      //   delete cso.spo.code
      //   delete cso.spo.version
      //   delete cso.spo.doc;
      //   cso.spo['fromCS'] = true;
      //   return cso.cs.shipmentLineItems.map(sli => ({ ...cso.spo, code: sli['doc'].code, version: sli['doc']. version, doc: sli['doc'] }))
      // }).reduce((a, c) => [...a, ...c], []);
      // console.log('cssspos', cssspos);
      // this.csTable = JSON.parse(JSON.stringify(cssspos && cssspos.length ? cssspos : spos));
      this.csTable = !['SPO','PFSPO'].includes(CompilationTypeData.get(this.compilation.type).code) && spos && JSON.parse(JSON.stringify(spos));

      const ocDocs = doc && doc.lineItems.map(m => m.relatedOCs);
      const ocs = ocDocs && ocDocs.reduce((a, c) => c && [...a, ...c], []);
      this.ocTable = ocs;

      const slis = this.compilation.shipmentLineItems;
      this.pfspoTable = slis;

      if (!this.compilation.transportRun) this.compilation.transportRun = new TransportRun();
      this.compilation.transportRun.transportStatus = this.getTransportStatusId();
      if (!this.compilation.transportRun.availabilityStatus) this.compilation.transportRun.availabilityStatus = 1;

      if (CompilationTypeData.get('CS').id === this.compilation.type) this.tree.linkedCSs = [this.compilation];

      if (['CN'].includes(CompilationTypeData.get(this.compilation.type).code)) {
        this.compilation.fiscalYear = this.tree.linkedIN?.fiscalYear;
      }
  
      // if (CompilationTypeData.get('OC').id !== this.compilation.type ) {
      //   // console.log('ngOnChanges report dates', this.compilation.vieDispatchDate, this.tree.linkedOC.vieDispatchDate);
      //   // if (new Date(this.compilation.vieDispatchDate) !== new Date(this.tree.linkedOC.vieDispatchDate)) {
      //   //   let trueOC = this.compilation;
      //   //   while (trueOC && CompilationTypeData.get('OC').id !== trueOC.type) {
      //   //     trueOC = await this.api.loadCompilationByCode(trueOC.parent);
      //   //   }
      //   //   this.api.debugLog(`track dispatch mismatch ${this.compilation?.code}`, {
      //   //     tree: this.tree.linkedOC?.code,
      //   //     oc: trueOC?.code,
      //   //     doc: this.compilation.code,
      //   //     dispatchDate: `${this.compilation.vieDispatchDate} => ${this.tree.linkedOC.vieDispatchDate} ==? ${trueOC.vieDispatchDate}`,
      //   //     etaCustomerDate: `${this.compilation.etaCustomerDate} => ${this.tree.linkedOC.etaCustomerDate} ==? ${trueOC.etaCustomerDate}`,
      //   //   }, EDebugType.log)
      //   // }
      //   let trueOC = this.compilation;
      //   while (trueOC && CompilationTypeData.get('OC').id !== trueOC.type) {
      //     trueOC = await this.api.loadCompilationByCode(trueOC.parent);
      //   }
      //   console.log('ngOnChanges report dates (2)', this.compilation.vieDispatchDate, this.tree.linkedOC.vieDispatchDate);
      //   this.compilation.vieDispatchDate = this.tree.linkedOC.vieDispatchDate;
      //   this.compilation.transferTime2 = this.tree.linkedOC.transferTime2;
      //   this.compilation.etaCustomerDate = this.tree.linkedOC.etaCustomerDate;
      //   this.compilation.expectedNextInvoiceDate = this.tree.linkedOC.expectedNextInvoiceDate;
      //   this.compilation.customerRequestedDeliveryDate = this.tree.linkedOC.customerRequestedDeliveryDate;
      //   this.compilation.customerAcceptedDeliveryDate = this.tree.linkedOC.customerAcceptedDeliveryDate;
      // }

      // console.log('pfspotable', this.transportStatus, this.pfspoTable);
      // TODO: put in ngDoCheck and check for changes!
      await this.evalFields();
      if (this.syncOnLoad) this.syncDisplayDates();
    }

    if (changes.tree || changes.compilation) {
      this.displayDateSections = DocConfig.getArray().filter(f => f.value.type === 'displayDate');
      for (const section of this.displayDateSections) {
        section.value.checked = this.compilation.visibleFields?.includes(section.key);
      }
      if (changes.compilation) {
        this.csSpoDatesUnlocked = false;
        this.referenceSpoCode = (this.compilation as any)?.refSpoCode || null;
      }
    }

  }

  blockCheck = false;
  async ngDoCheck(): Promise<void> {

    // this.currCodes = ((this.compilation.lineItems && this.compilation.lineItems.map(li => li.pfspo && li.pfspo.map(spo => spo.code)) || [])
    //   .reduce((acc, curr) => curr?.length && acc?.length && [...acc, ...curr], []) || []).filter((v, i, s) => s.indexOf(v) === i).sort();

    this.currCodes = Array.from(new Set(this.compilation.lineItems?.map(li => li?.pfspo).flatMap(spo => spo?.map(m => m?.code))));

    if (!this.blockCheck && this.currCodes && !this.tree.isLoading && JSON.stringify(this.currCodes) !== JSON.stringify(this.prevCodes)) {
      this.blockCheck = true;
      const newPfspos = [];
      const newCombinedShipments = []
      for (const code of this.currCodes) {
        let pfspo = this.tree.linkedPfspos && this.tree.linkedPfspos.find(f => f.code === code);
        if (!pfspo) {
          pfspo = await this.api.loadCompilationByCode(code);
          if (pfspo) pfspo.transportRun.csDoc = await this.api.findCombinedShipment(code);
        }
        newPfspos.push(pfspo);
        if (pfspo && pfspo.transportRun.csDoc) newCombinedShipments.push(pfspo.transportRun.csDoc);
      }
      this.tree.linkedPfspos = newPfspos;
      this.tree.linkedCSs = CompilationTypeData.get('CS').id === this.compilation.type ? [this.compilation] : newCombinedShipments.filter(notNull => notNull);

      this.evalFields();
      // this.syncDisplayDates();
    }
    this.prevCodes = this.currCodes;
    this.blockCheck = false;

    // this.currCodes = ((this.compilation.lineItems && this.compilation.lineItems.map(li => li.pfspo && li.pfspo.map(spo => spo.code)) || [])
    //   .reduce((acc, curr) => curr && [...acc, ...curr], []) || []).filter((v, i, s) => s.indexOf(v) === i).sort();

    // // TODO: replace compilation.tmp.associatedPfspos, compilation.tmp.associatedCombinedShipments with tree!
    // if (!this.blockCheck && this.currCodes && JSON.stringify(this.currCodes) !== JSON.stringify(this.prevCodes)) {
    //   this.blockCheck = true;
    //   this.compilation.tmp.associatedPfspos = [];
    //   this.compilation.tmp.associatedCombinedShipments = [];
    //   for (const code of this.currCodes) {
    //     if (!this.compilation.tmp.associatedPfspos.map(m => m.code).includes(code)) {
    //       const pfspo = await this.api.loadCompilationByCode(code);
    //       if (pfspo) this.compilation.tmp.associatedPfspos.push(pfspo);
    //       const cs = await this.api.findCombinedShipment(code);
    //       if (cs) this.compilation.tmp.associatedCombinedShipments.push(cs)
    //       console.log('pfspos, combinedshipments', this.compilation.tmp.associatedPfspos, this.compilation.tmp.associatedCombinedShipments)
    //     }
    //   }
    //   this.evalFields();
    //   // const newSpo = forced ? this.currCodes[0] : this.currCodes.filter(f => !this.prevCodes.includes(f))[0];
    //   // this.handlePfspoChange(newSpo);
    // }
    // this.prevCodes = this.currCodes;
    // this.blockCheck = false;
  }

  // async handlePfspoChange(newPfspo: string) {
  //   if (!newPfspo) return;

  //   console.log('pre handle pfspo exw date', this.compilation.exwJapanDate);
  //   // TODO: integrate with document tree;
  //   const fromCsDocs = [];
  //   for (const config of this.reportDateFields) {
  //     (config.value['getFromCS'] || []).forEach(doc => {
  //       if (!fromCsDocs.includes(doc)) fromCsDocs.push(doc)
  //     })
  //   }
  //   // console.log('fromCSDocs', fromCsDocs);

  //   if (fromCsDocs.includes(CompilationTypeData.get(this.compilation.type).code)) { // just load cs if needed
  //     const pfspo = newPfspo.length && await this.api.loadCompilationByCode(newPfspo);
  //     this.combinedShipment = pfspo.code && pfspo.code.length && await this.api.findCombinedShipment(pfspo.code);

  //     // take form combined shipment
  //     if (this.combinedShipment) {
  //       for (const config of this.reportDateFields) {

  //         if (DocConfig.getFromCS(config.key ,this.compilation.type)) this.compilation[config.key] = this.combinedShipment[config.key];
  //       }
  //       if (this.compilation.directDelivery) this.compilation.vieDispatchDate = this.combinedShipment.exwJapanDate;
  //     }
  //   }
  //   console.log('post handle pfspo exw date', this.compilation.exwJapanDate);
  // }

  // async getAssociatedPfspos() {
  //   const spos: any  = [];
  //   for (const cs of this.compilation.lineItems) {
  //     spos.push(...cs.pfspo);
  //   }
  //   for (const spo of spos) {
  //     spo.doc = await this.api.loadCompilationByCode(spo.code);
  //   }
  //   console.log('spos', spos);
  //   return spos
  // }

  getMinField(arr, field, subfield = null) {

    const fields = arr && (subfield ? arr.map(m => m && m[subfield] && m[subfield][field]) : arr.map(m => m && m[field]));
    const min = fields && fields.length && fields.reduce((a, c) => !a || c < a ? c : a);
    const idx = fields !== undefined && fields !== null ? fields.indexOf(min) : -1;
    return { min, idx };
  }

  getMaxField(arr, field, subfield = null) {
    const fields = arr && (subfield ? arr.map(m => m && m[subfield] && m[subfield][field]) : arr.map(m => m && m[field]));
    const max = fields && fields.length && fields.reduce((a, c) => !a || c > a ? c : a );
    const idx = fields !== undefined && fields !== null ? fields.indexOf(max) : -1;
    return { max, idx };
  }

  async evalFields() {
    const code = CompilationTypeData.get(this.compilation.type).code;
    if (!this.compilation.erpDate) this.compilation.erpDate = new ErpDate(); 

    console.log('crdd before', this.compilation.customerRequestedDeliveryDate);

    switch (code) {
      case 'CS':
        const slis = this.tree.docNode.doc.shipmentLineItems; // this.compilation.shipmentLineItems;
        // console.log('tree:', this.tree);
        this.compilation.readyForPickupDate = this.getMaxField(slis, 'readyForPickupDate', 'document').max;
        // console.log('slis----------------->',slis.map(m => m.document.code));
        // this.compilation.readyForPickupDate = null; // slis.map(m => m.document.readyForPickupDate).reduce((a, c) => !a || c > a ? c : a, []);
        // this.compilation.readyForPickupDate = slis.map(m => m.document.readyForPickupDate).reduce((a, c) => c && (c > a ? a : a)
        if (this.compilation.readyForPickupDate < new Date('2000-01-01')) this.compilation.readyForPickupDate = null;

        // console.log('m.document', slis.map(m => m.document));
        const doclis = (slis.map(m => m.document && m.document.lineItems) || []).reduce((a, c) => c && [...a, ...c], []);
        const csocs = doclis && doclis.reduce((a, c) => c['relatedOcs'] ? [...a, ...c['relatedOcs']] : a, [])

        const idx = this.getMinField(csocs, 'vieDispatchDate').idx;
        this.compilation.vieDispatchDate = (idx >= 0 && csocs[idx].vieDispatchDate) || undefined;
        this.compilation.erpDate.vieDispatchDate = (idx >= 0 && csocs[idx].erpDate?.vieDispatchDate) || undefined;
        this.compilation.transferTime2 = (idx >=0 && csocs[idx].transferTime2) || undefined;
        this.compilation.etaCustomerDate = (idx >= 0 && csocs[idx].etaCustomerDate) || undefined;
        this.compilation.erpDate.etaCustomerDate = (idx >= 0 && csocs[idx].erpDate?.etaCustomerDate) || undefined;
        this.compilation.customerRequestedDeliveryDate = (idx >=0 && csocs[idx].customerRequestedDeliveryDate) || undefined;
        this.compilation.erpDate.customerRequestedDeliveryDate = (idx >= 0 && csocs[idx].erpDate?.customerRequestedDeliveryDate) || undefined;
        this.compilation.customerAcceptedDeliveryDate = (idx >=0 && csocs[idx].customerAcceptedDeliveryDate) || undefined;
        this.compilation.erpDate.customerAcceptedDeliveryDate = (idx >= 0 && csocs[idx].erpDate?.customerAcceptedDeliveryDate) || undefined;
        break;

      case 'SPO':
      case 'PFSPO':
        const ocnodes = this.tree.docNode && this.tree.docNode.doc.lineItems.reduce((a, c) => c && c['relatedOCs'] && [...a, ...c['relatedOCs']], []);
        const ocs: CompilationModel[] = ocnodes && ocnodes.map(m => m.doc);
        if (ocs && ocs.length) {
          // this.compilation.tmp.vieDispatchDateCt = ocs.length;
          const ocidx = this.getMinField(ocs, 'vieDispatchDate').idx;
          this.compilation.vieDispatchDate = (ocidx >=0 && ocs[ocidx].vieDispatchDate) || undefined;
          this.compilation.erpDate.vieDispatchDate = (ocidx >=0 && ocs[ocidx].erpDate?.vieDispatchDate) || undefined;
          this.compilation.transferTime2 = (ocidx >=0 && ocs[ocidx].transferTime2) || undefined;
          this.compilation.etaCustomerDate = (ocidx >=0 && ocs[ocidx].etaCustomerDate) || undefined;
          this.compilation.erpDate.etaCustomerDate = (ocidx >=0 && ocs[ocidx].erpDate?.etaCustomerDate) || undefined;
          this.compilation.customerRequestedDeliveryDate = (ocidx >=0 && ocs[ocidx].customerRequestedDeliveryDate) || undefined;
          this.compilation.erpDate.customerRequestedDeliveryDate = (ocidx >=0 && ocs[ocidx].erpDate?.customerRequestedDeliveryDate) || undefined;
          this.compilation.customerAcceptedDeliveryDate = (ocidx >=0 && ocs[ocidx].customerAcceptedDeliveryDate) || undefined;
          this.compilation.erpDate.customerAcceptedDeliveryDate = (ocidx >=0 && ocs[ocidx].erpDate?.customerAcceptedDeliveryDate) || undefined;
        } else {
          this.compilation.vieDispatchDate
            = this.compilation.transferTime2
            = this.compilation.etaCustomerDate
            = this.compilation.customerRequestedDeliveryDate
            = this.compilation.customerAcceptedDeliveryDate
            = null;
        }
        // } else if (/^OC/.test(this.compilation.parent)) {
        //   this.compilation.vieDispatchDate = this.tree.linkedOC.vieDispatchDate;
        //   this.compilation.transferTime2 = this.tree.linkedOC.transferTime2;
        //   this.compilation.etaCustomerDate = this.tree.linkedOC.etaCustomerDate;
        //   this.compilation.customerRequestedDeliveryDate = this.tree.linkedOC.customerRequestedDeliveryDate;
        //   this.compilation.customerAcceptedDeliveryDate = this.tree.linkedOC.customerAcceptedDeliveryDate;
        // }
        if (this.tree.linkedCS) {
          // this.compilation.requestedExwDate = this.tree.linkedCS.requestedExwDate;
          this.compilation.exwJapanDate = this.tree.linkedCS.exwJapanDate;
          this.compilation.erpDate.exwJapanDate = this.tree.linkedCS.erpDate?.exwJapanDate;
          this.compilation.transferTime1 = this.tree.linkedCS.transferTime1;
          this.compilation.arrivingVieDate = this.tree.linkedCS.arrivingVieDate;
          this.compilation.erpDate.arrivingVieDate = this.tree.linkedCS.erpDate?.arrivingVieDate;
          if (!this.compilation.transportRun) this.compilation.transportRun = new TransportRun();
          this.compilation.transportRun.transportStatus = this.tree.linkedCS.transportRun && this.tree.linkedCS.transportRun.transportStatus;
          this.compilation.dateOfFAT = this.tree.linkedCS.dateOfFAT;
          this.compilation.erpDate.dateOfFAT = this.tree.linkedCS.erpDate?.dateOfFAT;
          this.compilation.dateOfSAT = this.tree.linkedCS.dateOfSAT;
          this.compilation.erpDate.dateOfSAT = this.tree.linkedCS.erpDate?.dateOfSAT;
          this.compilation.endOfWarranty = this.tree.linkedCS.endOfWarranty;
          this.compilation.erpDate.endOfWarranty = this.tree.linkedCS.erpDate?.endOfWarranty;
          this.compilation.dateOfDrawings = this.tree.linkedCS.dateOfDrawings;
          this.compilation.erpDate.dateOfDrawings = this.tree.linkedCS.erpDate?.dateOfDrawings;
          this.compilation.dateOfSourcing = this.tree.linkedCS.dateOfSourcing;
          this.compilation.erpDate.dateOfSourcing = this.tree.linkedCS.erpDate?.dateOfSourcing;
        }

        // calc spo availability statuss
        const spoQuantity = this.compilation.lineItems.reduce((a, c) => a + (+c.quantity), 0);
        const assignedOCQuantity = ocnodes?.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0) || 0;
        // console.log(this.compilation.code, this.compilation.lineItems);
        // console.log(this.compilation.code, ocnodes);
        // console.log('===>spoQuantity - assignedOCQuantity', spoQuantity, assignedOCQuantity);
        // item.relatedOCs?.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0);
        // return item.relatedOCs.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0);

        // let delQ = 0;
        // this.compilation.lineItems.forEach(li => {
        //   delQ += li.relatedOCs.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0);
        // })
        // console.log('===> checking delq, quantity', assignedOCQuantity, spoQuantity, ocnodes.length);

        if (ocnodes?.length) {
          if (this.compilation.lineItems?.length && ocnodes?.length && assignedOCQuantity && spoQuantity === assignedOCQuantity) {
            this.compilation.transportRun.availabilityStatus = AvailabilityStatusData.get('completed').id;
          } /*else {
            this.compilation.transportRun.availabilityStatus = AvailabilityStatusData.get('notCompleted').id;
          }*/
        }
        break;

      case 'OC':
        if (this.tree.linkedOC?.code !== this.compilation.code) {
          console.log(' ------------------- WRONG TREE -------------------------');
          this.api.debugLog(`evalFields WRONG TREE ${this.compilation.code}`, {
            doc: this.compilation.code,
            linkedOC: this.tree.linkedOC?.code,
            vieDispatchDate: `${this.compilation.vieDispatchDate} => ${this.compilation.directDelivery ? this.tree.linkedOC?.exwJapanDate : this.tree.linkedOC?.vieDispatchDate}`,
            etaCustomerDate: `${this.compilation.etaCustomerDate} => ${this.compilation.directDelivery ? this.tree.linkedOC?.arrivingVieDate : this.tree.linkedOC?.etaCustomerDate}`,
            directDelivery: `${this.compilation.directDelivery} => ${this.tree.directDelivery}`
          })
          return
        }
      case 'PL':
      case 'DN':
      case 'IN':
      case 'PFIN':
        // for (const config of this.reportDateFields) {
        //   if (DocConfig.getFromCS(config.key ,this.compilation.type)) {
        //     // this.compilation[config.key] = this.combinedShipment[config.key];
        //     this.compilation[config.key] = this.compilation.tmp.associatedCombinedShipments
        //   }
        // }
        // eslint-disable-next-line max-len
        let cs = (this.tree.linkedPfspos && this.tree.linkedPfspos.map(spo => spo && spo.transportRun && spo.transportRun.csDoc) || []).filter(f => f);
        let pfspos = this.tree.linkedPfspos;
        if (this.referenceSpoCode) {
          const ref = pfspos && pfspos.find(spo => spo && spo.code === this.referenceSpoCode);
          if (ref) {
            pfspos = [ref];
            cs = ref.transportRun?.csDoc ? [ref.transportRun.csDoc] : [];
          }
        }

        const csIdx = this.getMaxField(cs, 'arrivingVieDate').idx;
        const pfspoIdx = this.getMaxField(pfspos, 'arrivingVieDate').idx;

        // if (this.compilation.tmp) this.compilation.tmp.exwJapanDateCt = csIdx >= 0 && cs ? cs.length : pfspos && pfspos.length;
        // if (this.compilation.tmp) this.compilation.tmp.hasCS = csIdx >= 0 && cs;
        
        this.compilation.requestedExwDate
          = (csIdx >= 0 && cs[csIdx].requestedExwDate) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].requestedExwDate) || undefined;
        this.compilation.exwJapanDate
          = (csIdx >= 0 && cs[csIdx].exwJapanDate) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].exwJapanDate) || undefined;
        this.compilation.erpDate.exwJapanDate
          = (csIdx >= 0 && cs[csIdx].erpDate?.exwJapanDate) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.exwJapanDate) || undefined;
        this.compilation.internalExwDate
          = (csIdx >= 0 && cs[csIdx].internalExwDate) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].internalExwDate) || undefined;
        this.compilation.erpDate.internalExwDate
          = (csIdx >= 0 && cs[csIdx].erpDate?.internalExwDate) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.internalExwDate) || undefined;
        this.compilation.transferTime1
          = (csIdx >= 0 && cs[csIdx].transferTime1) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].transferTime1) || undefined;
        this.compilation.arrivingVieDate
          = (csIdx >= 0 && cs[csIdx].arrivingVieDate) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].arrivingVieDate) || undefined;
        this.compilation.erpDate.arrivingVieDate
          = (csIdx >= 0 && cs[csIdx].erpDate?.arrivingVieDate) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.arrivingVieDate) || undefined;
        this.compilation.dateOfFAT
          = (csIdx >= 0 && cs[csIdx].dateOfFAT) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].dateOfFAT) || undefined;
        this.compilation.erpDate.dateOfFAT
          = (csIdx >= 0 && cs[csIdx].erpDate?.dateOfFAT) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.dateOfFAT) || undefined;
        this.compilation.dateOfSAT
          = (csIdx >= 0 && cs[csIdx].dateOfSAT) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].dateOfSAT) || undefined;
        this.compilation.erpDate.dateOfSAT
          = (csIdx >= 0 && cs[csIdx].erpDate?.dateOfSAT) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.dateOfSAT) || undefined;
        this.compilation.endOfWarranty
          = (csIdx >= 0 && cs[csIdx].endOfWarranty) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].endOfWarranty) || undefined;
        this.compilation.erpDate.endOfWarranty
          = (csIdx >= 0 && cs[csIdx].erpDate?.endOfWarranty) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.endOfWarranty) || undefined;
        this.compilation.dateOfDrawings
          = (csIdx >= 0 && cs[csIdx].dateOfDrawings) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].dateOfDrawings) || undefined;
        this.compilation.erpDate.dateOfDrawings
          = (csIdx >= 0 && cs[csIdx].erpDate?.dateOfDrawings) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.dateOfDrawings) || undefined;
        this.compilation.dateOfSourcing
          = (csIdx >= 0 && cs[csIdx].dateOfSourcing) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].dateOfSourcing) || undefined;
        this.compilation.erpDate.dateOfSourcing
          = (csIdx >= 0 && cs[csIdx].erpDate?.dateOfSourcing) || (pfspoIdx >= 0 && pfspos[pfspoIdx] && pfspos[pfspoIdx].erpDate?.dateOfSourcing) || undefined;

        let trueOC = this.compilation;
        while (trueOC && CompilationTypeData.get('OC').id !== trueOC.type) {
          trueOC = await this.api.loadCompilationByCode(trueOC.parent);
        }
  
        const ocDoc = trueOC; // this.tree.linkedOC || this.compilation; /* fallback should never happen TODO: check if this is save */

        this.compilation.customerAcceptedDeliveryDate = ocDoc.customerAcceptedDeliveryDate;
        this.compilation.erpDate.customerAcceptedDeliveryDate = ocDoc.erpDate?.customerAcceptedDeliveryDate;
        this.compilation.customerRequestedDeliveryDate = ocDoc.customerRequestedDeliveryDate;
        this.compilation.erpDate.customerRequestedDeliveryDate = ocDoc.erpDate?.customerRequestedDeliveryDate;

        if (!ocDoc) break;

        // if (this.compilation.vieDispatchDate !== ocDoc.vieDispatchDate) {
        //   console.log(`debugLog evalFields dispatch date mismatch
        //     doc: ${this.compilation.code}
        //     ocDoc: ${this.compilation.ocCode}
        //     vieDispatchDate: ${this.compilation.vieDispatchDate} => ${ocDoc.vieDispatchDate}
        //     directDel: ${this.compilation.directDelivery}
        //   `)
        // }

        this.compilation.directDelivery = this.tree.directDelivery;

        if (this.compilation.directDelivery) {
          this.compilation.vieDispatchDate = ocDoc.exwJapanDate;
          this.compilation.erpDate.vieDispatchDate = ocDoc.erpDate?.exwJapanDate;
          this.compilation.transferTime2 = ocDoc.transferTime1;
          this.compilation.etaCustomerDate = ocDoc.arrivingVieDate;
          this.compilation.erpDate.etaCustomerDate = ocDoc.erpDate?.arrivingVieDate;
          if (this.compilation.nextInvoiceDateAttached) {
            this.compilation.expectedNextInvoiceDate = ocDoc.exwJapanDate;
            this.compilation.erpDate.expectedNextInvoiceDate = ocDoc.erpDate?.exwJapanDate;
          }
        } else {
          this.compilation.vieDispatchDate = ocDoc.vieDispatchDate;
          this.compilation.erpDate.vieDispatchDate = ocDoc.erpDate?.vieDispatchDate;
          this.compilation.transferTime2 = ocDoc.transferTime2;
          this.compilation.etaCustomerDate = ocDoc.etaCustomerDate;
          this.compilation.erpDate.etaCustomerDate = ocDoc.erpDate?.etaCustomerDate;
          if (this.compilation.nextInvoiceDateAttached) {
            this.compilation.expectedNextInvoiceDate = ocDoc.expectedNextInvoiceDate;
            this.compilation.erpDate.expectedNextInvoiceDate = ocDoc.erpDate?.expectedNextInvoiceDate;
          }
        }
        // this.syncDisplayDates();

        break;
    }

    console.log('crdd after', this.compilation.customerRequestedDeliveryDate);
    
    // TODO: remove in v2 and migrate nextInvoiceDateAttached => dateOfDispatch
    if (this.compilation.nextInvoiceDateAttached && !this.compilation.nextInvoiceDateRef) {
      this.compilation.nextInvoiceDateRef = 'dateOfDispatch';
      this.compilation.nextInvoiceDateAttached = null;
    }

    // this.syncDisplayDates(); no sync -> update when in edit mode
  }

  transferSpoDateToOc(field: string) {
    const ocs = this.compilation.lineItems.flatMap(li => li.relatedOCs.map(m =>m.doc.code));
    [this.compilation.code, ...ocs].forEach(code => {
      this.api.updateField(code, field, this.compilation[field]);
      this.compilation.lineItems.flatMap(li => li.relatedOCs).forEach(oc => oc.doc[field] = this.compilation[field])
      this.ocTable.forEach(oc => oc.doc[field] = this.compilation[field]);
    })
    console.log(this.compilation.lineItems);
  }

  reportDateFieldChanged(field: string) {

    switch (field) {

      case 'exwJapanDate':
        if (this.compilation.transferTime1) this.compilation.arrivingVieDate = moment(this.compilation.exwJapanDate)
          .add(this.compilation.transferTime1, 'days').toDate();
        this.data.setCSIdentifier(this.compilation);
        break;

      case 'transferTime1':
        this.compilation.arrivingVieDate = moment(this.compilation.exwJapanDate)
          .add(this.compilation.transferTime1, 'days').toDate();
        break;

      case 'arrivingVieDate':
        this.compilation.transferTime1 = moment(this.compilation.arrivingVieDate)
          .diff(moment(this.compilation.exwJapanDate), 'days');
        break;

      case 'vieDispatchDate':
        if (['SPO', 'PFSPO'].includes(CompilationTypeData.get(this.compilation.type).code)) this.transferSpoDateToOc(field);
        if (this.compilation.transferTime2) this.compilation.etaCustomerDate = moment(this.compilation.vieDispatchDate)
          .add(this.compilation.transferTime2, 'days').toDate();
        if (!this.compilation.customerRequestedDeliveryDate) this.compilation.customerRequestedDeliveryDate = this.compilation.etaCustomerDate;
        if (!this.compilation.customerAcceptedDeliveryDate) this.compilation.customerAcceptedDeliveryDate = this.compilation.etaCustomerDate;
        // if (this.compilation.nextInvoiceDateAttached) this.compilation.expectedNextInvoiceDate = this.compilation.vieDispatchDate;
        if (this.compilation.nextInvoiceDateAttached || this.compilation.nextInvoiceDateRef) {
          this.compilation.expectedNextInvoiceDate = this.compilation.nextInvoiceDateRef 
            ? this.compilation[this.compilation.nextInvoiceDateRef]
            : this.compilation.vieDispatchDate;
          this.data.fiscalYearUpdate(this.compilation);
          break;
        }

      case 'transferTime2':
        this.compilation.etaCustomerDate = moment(this.compilation.vieDispatchDate)
          .add(this.compilation.transferTime2, 'days').toDate();
        if (!this.compilation.customerRequestedDeliveryDate) this.compilation.customerRequestedDeliveryDate = this.compilation.etaCustomerDate;
        if (!this.compilation.customerAcceptedDeliveryDate) this.compilation.customerAcceptedDeliveryDate = this.compilation.etaCustomerDate;
        break;

      case 'etaCustomerDate':
        this.compilation.transferTime2 = moment(this.compilation.etaCustomerDate)
          .diff(moment(this.compilation.vieDispatchDate), 'days');
        if (!this.compilation.customerRequestedDeliveryDate) this.compilation.customerRequestedDeliveryDate = this.compilation.etaCustomerDate;
        if (!this.compilation.customerAcceptedDeliveryDate) this.compilation.customerAcceptedDeliveryDate = this.compilation.etaCustomerDate;
        break;

      case 'customerRequestedDeliveryDate':
        if (!this.compilation.customerAcceptedDeliveryDate) {
          this.compilation.customerAcceptedDeliveryDate = this.compilation.customerRequestedDeliveryDate;
        }
        break;
      case 'dateOfSAT':
      case 'warrantyMonths':
        if (this.compilation.dateOfSAT && this.compilation.warrantyMonths) {
          this.compilation.endOfWarranty = moment(this.compilation.dateOfSAT).add(this.compilation.warrantyMonths, 'months').toDate();
        }
        break;
    }
    this.syncDisplayDates();

    // update future ErpDate instance TODO: unify compilation dates with erp dates
    if (this.compilation.erpDate?.[field]) this.compilation.erpDate[field].val = this.compilation[field];

    this.dateChange.emit();
  }

  syncDisplayDates() {
    // if (this.compilation.exwJapanDate) this.compilation.exwDate = this.compilation.exwJapanDate;
    // if (this.compilation.arrivingVieDate) this.compilation.dateOfVieArrival = this.compilation.arrivingVieDate;
    // if (this.compilation.vieDispatchDate) this.compilation.dateOfDispatch = this.compilation.vieDispatchDate;
    // if (this.compilation.etaCustomerDate) this.compilation.dateOfDelivery = this.compilation.etaCustomerDate;
    // if (this.compilation.readyForPickupDate) this.compilation.dateOfPickup = this.compilation.readyForPickupDate;

    this.compilation.exwDate = this.compilation.exwJapanDate;
    this.compilation.dateOfVieArrival = this.compilation.arrivingVieDate;
    this.compilation.dateOfDispatch = this.compilation.vieDispatchDate;
    this.compilation.dateOfDelivery = this.compilation.etaCustomerDate;
    this.compilation.dateOfPickup = this.compilation.readyForPickupDate;

    // this.api.debugLog(`syncDisplayDates ${this.compilation.code}`, {
    //   dispatchDate: `dateOfDispatch = ${this.compilation.vieDispatchDate}`,
    //   etaCustomer: `etaCustomerDate = ${this.compilation.etaCustomerDate}`
    // }, )
  }

  async save() {

    // TODO: sync in backend
    const syncDocs = ['OC', 'PL', 'DN', 'IN', 'PFIN'];
    if (syncDocs.includes(CompilationTypeData.get(this.compilation.type).code)) {
      // const tree = await DocumentTree.getConnectedDocs(this.api, this.compilation.code);
      const tree = this.tree.getFlat();


      for (const doc of tree) {
        if (!doc) continue;
        if (syncDocs.includes(CompilationTypeData.get(doc.type).code)) {

          for (const field of this.reportDateFields) {

            let oldField = doc[field.key];
            let newField = this.compilation[field.key];
            if (DocConfig.get(field.key).type === 'reportDate') {
              oldField = (oldField && new Date(oldField).toISOString().replace(/T.*/, '')) || 'undefined';
              newField = (newField && new Date(newField).toISOString().replace(/T.*/, '')) || 'undefined';
            }
            if (
              !DocConfig.getFromCS(field.key ,this.compilation.type)
              && oldField !== newField
            ) {

              if (doc.code === this.compilation.code) {
                // await Changelog.addAndSaveAutolog(doc, this.auth.user, this.api, [{
                //   quickText: 'updated ' + DocConfig.get(field.key).label,
                //   text: `from ${oldField} to ${newField}`,
                // }]);
                await Changelog.addAutolog(doc,this.auth.user, this.api,[{
                  quickText: 'updated ' + DocConfig.get(field.key).label,
                  text: `from ${oldField} to ${newField}`,
                }])
              } else if (!/^OC/.test(doc.code)) {
                await Changelog.addAndSaveAutolog(doc, this.auth.user, this.api, [{
                  quickText: 'updated ' + DocConfig.get(field.key).label,
                  text: `from ${oldField} to ${newField} in ${getDocumentNumber(this.compilation)}`,
                }]);
              }
              if (!/^OC/.test(doc.code)) await this.api.updateField(doc.code, field.key, this.compilation[field.key]);

            }
          }
          const oldField = doc.directDelivery;
          const newField = this.compilation.directDelivery;
          if (oldField !== newField) await this.api.updateField(doc.code, 'directDelivery', this.compilation.directDelivery);
        }
      }
      this.api.debugLog(`save report dates ${this.compilation.code}`, {
        dispatchDate: `vieDispatchDate: ${this.compilation.vieDispatchDate}, dateOfDispatch: ${this.compilation.dateOfDispatch}`,
        etaCustomerDate: `etaCustomerDate: ${this.compilation.etaCustomerDate}, dateOfDelivery: ${this.compilation.dateOfDelivery}`,
      })

    }

    await this.saveUnlockedCsSpoDates().then(() => this.ngOnInit());
  }

  directDeliveryChanged(direct: boolean) {
    this.evalFields();
  }

  pfspoWithShipmentChanged(withShipment: boolean) {
    this.evalFields();
  }

  checkSpoStatus(radioItem: number) {
    if (this.disabled) return false;
    return true;
    if (+this.compilation.type === CompilationTypeData.get('CS').id) {
      let enableTransport = true;
      this.compilation.shipmentLineItems.forEach(li => {
        if (radioItem > 1 && !li.document.transportRun
          || (li.document.transportRun && !li.document.transportRun.spoStatus)) {
          enableTransport = false;
        }
      })
      return enableTransport;
    } else if (+this.compilation.type === CompilationTypeData.get('SPO').id
      || +this.compilation.type === CompilationTypeData.get('PFSPO').id) {
      return !this.tree.linkedCS
    } else {
      return false;
    }
  }

  getTransportStatusId() {
    let status = this.compilation.transportRun.transportStatus || 1;
    if (!['PFSPO', 'SPO', 'CS'].includes(CompilationTypeData.get(+this.compilation.type).code) && this.tree.linkedCSs) {
      const stati = this.tree.linkedCSs.map(m => m && m.transportRun && m.transportRun.transportStatus).filter(f => f);
      status = stati && stati.length ? Math.min(...stati) : 1;
    }
    this.compilation.transportRun.transportStatus = status;
    return status;
  }

  getTransportStatus(spo) {
    return spo && spo.doc && spo.doc.transportRun ? (TransportStatusData.get(spo.doc.transportRun.transportStatus) || {} as any).name : '';
  }

  isCheckBox(section) {
    return section && section.checkedDocs !== undefined && section.checkedDocs !== null;
  }

  showDisplayDates() {
    // console.log(
    //   'display dates:',
    //   this.data.visibleMap.dateOfService,
    //   this.data.visibleMap.exwDate,
    //   (!print || this.compilation.dateOfService || this.compilation.legacyDateOfService),
    //   (!print || this.compilation.dateOfPickup),
    //   (!print || this.compilation.legacyExwDate || this.compilation.exwDate),
    //   (!print || this.compilation.legacyDateOfVieArrival || this.compilation.dateOfVieArrival),
    //   (!print || this.compilation.legacyDateOfDispatch || this.compilation.dateOfDispatch),
    //   (!print || this.compilation.legacyDateOfDelivery || this.compilation.dateOfDelivery),
    // )
    // console.log('showDisplayDates', this.data.visibleMap)
    return (
      (this.data.visibleMap.dateOfService
        && DocConfig.get('dateOfService').checked
        && (!print || this.compilation.dateOfService || this.compilation.legacyDateOfService)
        && this.compilation.invoiceType === 'service')
      || (this.data.visibleMap.dateOfPickup
        && DocConfig.get('dateOfPickup').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.dateOfPickup))
      || (this.data.visibleMap.exwDate
        && DocConfig.get('exwDate').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.legacyExwDate || this.compilation.exwDate))
      || (this.data.visibleMap.dateOfVieArrival
        && DocConfig.get('dateOfVieArrival').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.legacyDateOfVieArrival || this.compilation.dateOfVieArrival))
      || (this.data.visibleMap.dateOfDispatch
        && DocConfig.get('dateOfDispatch').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.legacyDateOfDispatch || this.compilation.dateOfDispatch))
      || (this.data.visibleMap.dateOfDelivery
        && DocConfig.get('dateOfDelivery').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.legacyDateOfDelivery || this.compilation.dateOfDelivery))
      || (this.data.visibleMap.dateOfFAT
        && DocConfig.get('dateOfFAT').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.dateOfFAT))
      || (this.data.visibleMap.dateOfSAT
        && DocConfig.get('dateOfSAT').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.dateOfSAT))
      || (this.data.visibleMap.endOfWarranty
         && DocConfig.get('endOfWarranty').checked
         && (this.compilation.invoiceType !== 'service')
         && (!print || this.compilation.endOfWarranty))
      || (this.data.visibleMap.dateOfDrawings
        && DocConfig.get('dateOfDrawings').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.dateOfDrawings))
      || (this.data.visibleMap.dateOfSourcing
        && DocConfig.get('dateOfSourcing').checked
        && (this.compilation.invoiceType !== 'service')
        && (!print || this.compilation.dateOfSourcing))
      )
  }

  toggleItem(section) {
    if (!section) return;
    if (!section.checked) {
      section.checked = true;
      if (!this.compilation.visibleFields.includes(section.name)) this.compilation.visibleFields.push(section.name);
    } else {
      section.checked = false;
      this.compilation.visibleFields = this.compilation.visibleFields.filter(f => f !== section.name);
    }
  }

  // toggleNextInvoiceDateToDispatchDateAttached() {
  //   this.compilation.nextInvoiceDateAttached = !this.compilation.nextInvoiceDateAttached;
  //   if (this.compilation.nextInvoiceDateAttached) {
  //     this.compilation.expectedNextInvoiceDate = this.compilation.vieDispatchDate;
  //   }
  // }

  isNRVIDelivery() {
    return /Nippon Rika Vincent Industrie/.test(this.compilation.deliveryAddress)
  }

  loadDateTextStore() {
    this.dateTextOptions = this.data.compilationData?.displayDatesStore.map(m => ({ id: m, name: m }))
  }
  dateTextOptionsChanged(text: string) {
    this.compilation.dateText = text;
  }
  async addDateText() {
    await this.api.saveCompilationData('displayDatesStore', this.compilation.dateText, true);
    await this.data.reloadCompilationData();
    this.loadDateTextStore();
  }
  async removeDateText() {
    await this.api.saveCompilationData('displayDatesStore', this.compilation.dateText, false);
    await this.data.reloadCompilationData();
    this.loadDateTextStore();
  }

}
